import { Id } from '../../convex/_generated/dataModel';

export const getCloudUrl = (activityId: string) => {
  return `${process.env.NEXT_PUBLIC_R2_ENDPOINT}/${activityId}.mp4`;
};

export const markForDeletion = ({
  vods,
  bytesLimit,
  incomingVodSizeInBytes,
}: {
  vods: { _id: Id<'cloud_vods'>; activityId: Id<'activities'>; sizeInBytes: number; _creationTime: number }[];
  incomingVodSizeInBytes: number;
  bytesLimit: number;
}): { _id: Id<'cloud_vods'>; activityId: Id<'activities'> }[] => {
  const bytesToBeConsumed = vods.reduce((acc, vod) => acc + vod.sizeInBytes, 0) + incomingVodSizeInBytes;
  console.log({ bytesToBeConsumed, bytesLimit });
  if (bytesToBeConsumed <= bytesLimit) {
    return [];
  }
  let bytesNeededToFree = bytesToBeConsumed - bytesLimit;
  const vodsByCreationTimeOldestFirst = vods.slice().sort((a, b) => a._creationTime - b._creationTime);
  const vodsToDelete: { _id: Id<'cloud_vods'>; activityId: Id<'activities'> }[] = [];
  for (const vod of vodsByCreationTimeOldestFirst) {
    bytesNeededToFree -= vod.sizeInBytes;
    vodsToDelete.push({ _id: vod._id, activityId: vod.activityId });
    if (bytesNeededToFree <= 0) {
      break;
    }
  }
  console.log(vodsToDelete);
  return vodsToDelete;
};
